module.exports = __webpack_public_path__ + "media/images/default/default_user_icon_type_2-5417dada3ae96e76d7c9b6005f90a4a5.png";